import './styles/index.scss';

import './js/answer-list';
import './js/audioplayer';
import './js/bird-descr';
import './js/birds-data';
import './js/input-progress';
import './js/language';
import './js/next-question';
import './js/question';
import './js/random';
import './js/score';
import './js/results';
import './js/change-theme'

console.log('270/270: I preferred to implement a quiz theme change on the main page instead of the gallery')